import React from "react";
import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_paradise-central/artifacts/mn1zkawt_DJI_0038.JPG";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${HERO_IMG})`, filter: "brightness(1.18) saturate(1.05)" }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/35 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/60 via-transparent to-transparent" />

      {/* Top overline */}
      <div className="absolute top-28 left-6 md:left-10 z-10 flex items-center gap-3">
        <span className="w-8 h-px bg-[#E2B464]" />
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E2B464]">
          Victoria Flats · Central Otago · NZ
        </span>
      </div>

      <div className="relative z-10 max-w-[1600px] mx-auto w-full px-6 md:px-10 pb-20 md:pb-28">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-5xl"
        >
          <h1 className="font-display font-light text-white text-5xl sm:text-6xl lg:text-[6.5rem] leading-[0.9] tracking-tighter">
            A filmmaker's
            <br />
            <span className="italic font-extralight text-[#E2B464]">Paradise</span>{" "}
            <span className="font-extrabold">where</span>
            <br />
            cinema lives.
          </h1>
          <div className="mt-10 flex flex-col sm:flex-row sm:items-end gap-8 sm:gap-16">
            <p className="text-zinc-300 text-base md:text-lg max-w-md leading-relaxed">
              The South Island's first wet-weather cover studio and a fully
              serviced base-camp hub, set on 45 hectares in Gibbston Valley,
              within the 40 km production radius of Queenstown, Cromwell and
              Arrowtown.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#locations"
                data-testid="hero-explore-button"
                className="btn-primary px-6 py-3.5 text-sm font-medium inline-flex items-center gap-2"
              >
                Scout Locations
              </a>
              <a
                href="#contact"
                data-testid="hero-contact-button"
                className="btn-ghost px-6 py-3.5 text-sm font-medium inline-flex items-center gap-2"
              >
                Brief us
              </a>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Bottom corner tickers */}
      <div className="absolute bottom-6 right-6 md:right-10 z-10 hidden md:flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
        <ArrowDown className="w-3 h-3 animate-bounce" />
        <span>Scroll · 45° 02' S, 168° 49' E</span>
      </div>
    </section>
  );
}
